<template>
    <div>
        <div class="card card-box mb-3">
            <div class="card-body p-4">
                <h5 class="font-weight-bold">Tata Laksana</h5>
                <b-row class="mt-3">
                    <b-col md="6" lg="6" v-show="kategoriPasien == 2">
                        <h6 class="font-weight-bold">Ditanggung BPJS</h6>
                        <h6 class="mt-3 font-weight-bold">Tindakan <span class="ml-2"
                                v-if="tlPembayaranBPJSTindakan.length == 0">-</span></h6>
                        <template v-if="tlPembayaranBPJSTindakan.length > 0">
                            <table class="table table-borderless">
                                <tbody>
                                    <tr v-for="tl in tlPembayaranBPJSTindakan" :key="tl.id + 'z'">
                                        <td class="p-0" style="width: 50%;">{{ tl.nama_layanan }}</td>
                                        <td style="width: 5%;">{{ tl.quantity }}</td>
                                        <td>{{ tl.keterangan }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </template>
                        <h6 class="mt-3 font-weight-bold">Obat <span class="ml-2"
                                v-if="tlPembayaranBPJSObat.length == 0">-</span></h6>
                        <table class="table table-borderless">
                            <tbody>
                                <tr v-for="(item1, index1) in tlPembayaranBPJSObat" :key="index1 + 'y'">
                                    <td class="p-0" style="width: 50%;">{{ item1.nama_layanan }}</td>
                                    <td style="width: 5%;">{{ item1.quantity }}</td>
                                    <td>{{ item1.satuan || '-' }}</td>
                                    <td>
                                        {{ item1.keterangan }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </b-col>
                    <b-col md="6" lg="6">
                        <h6 class="font-weight-bold" v-show="kategoriPasien == 2">Tidak Ditanggung BPJS</h6>
                        <h6 class="mt-3 font-weight-bold">
                            Tindakan
                            <span class="ml-2" v-if="tlPembayaranTindakan.length == 0">-</span>
                        </h6>
                        
                        <template v-if="tlPembayaranTindakan.length > 0">
                            <table class="table table-borderless">
                                <tbody>
                                    <tr v-for="tl in tlPembayaranTindakan" :key="tl.id + Math.floor(Math.random() * 1000)">
                                        <td class="p-0" style="width: 50%;">{{ tl.nama_layanan }}</td>
                                        <td style="width: 5%;">{{ tl.quantity }}</td>
                                        <td>{{ tl.keterangan }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </template>
                        <h6 class="mt-3 font-weight-bold">Obat & BHP <span class="ml-2"
                                v-if="tlPembayaranObat.length == 0">-</span></h6>
                        <table class="table table-borderless">
                            <tbody>
                                <tr v-for="(item1, index1) in tlPembayaranObat" :key="(index1 + 'a')">
                                    <td class="p-0">{{ item1.nama_layanan }}</td>
                                    <td>{{ item1.quantity }}</td>
                                    <td>{{ item1.satuan ? item1.satuan.name : '-' }}</td>
                                    <td>
                                        {{ (item1.aturan_pakai ? item1.aturan_pakai : '') + (item1.aturan_pakai &&
                                            item1.keterangan ? ', ' + item1.keterangan : '') }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </b-col>

                </b-row>
                <b-row v-if="kategoriPasien == 2">
                    <b-col md="12" lg="12">
                        <h6 class="mt-3 font-weight-bold">Terapi Obat</h6>
                        <p>
                            {{ bpjs_health_data && checkValueData(bpjs_health_data.terapi_obat)  ? bpjs_health_data.terapi_obat : '-' }}
                        </p>
                    </b-col>
                </b-row>
                <b-row v-if="kategoriPasien == 2">
                    <b-col md="12" lg="12">
                        <h6 class="mt-3 font-weight-bold">Terapi Non Obat</h6>
                        <p>
                            {{ bpjs_health_data && checkValueData(bpjs_health_data.terapi_non_obat)  ? bpjs_health_data.terapi_non_obat : '-' }}
                        </p>
                    </b-col>
                </b-row>
                <b-row v-if="kategoriPasien == 2">
                    <b-col md="12" lg="12">
                        <h6 class="mt-3 font-weight-bold">BMHP</h6>
                        <p>
                            {{ bpjs_health_data && checkValueData(bpjs_health_data.bmhp) ? bpjs_health_data.bmhp : '-' }}
                        </p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12" lg="12">
                        <h6 class="mt-3 font-weight-bold">Tindakan, Terapi dan Saran</h6>
                        <div v-html="this.dataRM.tatalaksana.notes || '-'"></div>
                        <template v-if="dataRM.tatalaksana.draw_path !== null">
                            <img :src="dataRM.tatalaksana.draw_path" class="img-fluid" alt="img" />
                        </template>
                    </b-col>
                </b-row>
            </div>
        </div>
        
        <div class="card card-box mb-3">
            <div class="card-body p-4">
                <b-row>
                    <b-col lg="6" md="6">
                        <template v-if="dataRM.transklinik.kategori_id == 2 || dataRM.transklinik.tgl_next_konsultasi !== '1970-01-01'">
                            <h5 class="font-weight-bold">Konsultasi Selanjutnya</h5>
                            <b-row class="mt-3">
                                <b-col md="12" lg="12" v-if="dataRM.transklinik.kategori_id == 2">
                                    <div class="form-group row mb-header">
                                        <label for="staticEmail" class="col-sm-4 col-form-label pr-0">Status Pulang</label>
                                        <div class="col-sm-8 form-control-plaintext">
                                            : {{ setStatusPulang() }}
                                        </div>
                                    </div>
                                </b-col>
                                <template v-if="dataRM.bpjs_nmStatusPulang == 'Rujukan'">
                                    <b-col md="12" lg="12" v-if="tacc.type == 'Y'">
                                        <div class="form-group row mb-header">
                                            <label for="staticEmail" class="col-sm-4 col-form-label pr-0">Faktor Rujukan</label>
                                            <div class="col-sm-8 form-control-plaintext">
                                                : {{ tacc.faktor }}
                                            </div>
                                        </div>
                                    </b-col>
                                    <b-col md="12" lg="12" v-if="tacc.type == 'Y'">
                                        <div class="form-group row mb-header">
                                            <label for="staticEmail" class="col-sm-4 col-form-label pr-0">Alasan</label>
                                            <div class="col-sm-8 form-control-plaintext">
                                                : {{ tacc.alasan }}
                                            </div>
                                        </div>
                                    </b-col>
                                    <b-col md="12" lg="12">
                                        <div class="form-group row mb-header">
                                            <label for="staticEmail" class="col-sm-4 col-form-label pr-0">PPK Rujukan</label>
                                            <div class="col-sm-8 form-control-plaintext">
                                                : {{ datarujukan.faskes || '-' }}
                                            </div>
                                        </div>
                                    </b-col>
                                    <b-col md="12" lg="12">
                                        <div class="form-group row mb-header">
                                            <label for="staticEmail" class="col-sm-4 col-form-label pr-0">Spesialis/Subspesialis</label>
                                            <div class="col-sm-8 form-control-plaintext">
                                                :
                                                <span v-if="datarujukan.spesialis && datarujukan.subspesialis">
                                                    {{ datarujukan.spesialis || '-' }}{{ datarujukan.subspesialis ? ` /
                                                    ${datarujukan.subspesialis}` : '' }}
                                                </span>
                                                <span v-else-if="datarujukan.spesialis">{{ datarujukan.spesialis || '-' }}</span>
                                                <span v-else-if="datarujukan.subspesialis">{{ datarujukan.subspesialis
                                                    || '-' }}</span>
                                                <span v-else>-</span>
                                            </div>
                                        </div>
                                    </b-col>
                                    <b-col md="12" lg="12">
                                        <div class="form-group row mb-header">
                                            <label for="staticEmail" class="col-sm-4 col-form-label pr-0">Catatan</label>
                                            <div class="col-sm-8 form-control-plaintext">
                                                : {{ datarujukan.catatan || '-' }}
                                            </div>
                                        </div>
                                    </b-col>
                                    <b-col md="12" lg="12">
                                        <div class="form-group row mb-header">
                                            <label for="staticEmail" class="col-sm-4 col-form-label">Tgl. Rencana
                                                Berkunjung</label>
                                            <div class="col-sm-8 form-control-plaintext">
                                                : {{ datarujukan.tglrujukan || '-' }}
                                            </div>
                                        </div>
                                    </b-col>
                                </template>

                                <b-col md="12" lg="12" v-if="dataRM.transklinik.tgl_next_konsultasi !== '1970-01-01'">
                                    <div class="form-group row mb-header">
                                        <label for="staticEmail" class="col-sm-4 col-form-label">Konsultasi Selanjutnya</label>
                                        <div class="col-sm-8 form-control-plaintext">
                                            : {{ dateFormat(dataRM.transklinik.tgl_next_konsultasi) }}
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>
                        </template>
                    </b-col>
                    
                    <b-col md="6" lg="6">
                        <h5 class="font-weight-bold">Surat Penunjang</h5>
                        <h6 class="mt-3">Uploaded file:</h6>
                        <template v-if="TransKlinikIDRiwayatRekamMedis">
                            <SuratPenunjangRiwayatRekamMedis :TransKlinikID="TransKlinikIDRiwayatRekamMedis"
                                :propSuratRujukBpjs="SuratRujukBpjs" />
                        </template>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import { mapGetters } from 'vuex';
    import rekamMedisMixin from '../mixins';

    export default {
        name: 'Plan',
        mixins: [rekamMedisMixin],
        props: ['dataRM', 'dataRujukan'],
        components: {
            SuratPenunjangRiwayatRekamMedis: () =>
                import('../../../components/SuratPenunjang/SuratPenunjangRiwayatRekamMedis.vue'),
        },
        computed: {
            ...mapGetters(['getKlinikId']),
        },
        data() {
            return {
                tlPembayaranTindakan: [],
                tlPembayaranObat: [],
                tlPembayaranBPJSTindakan: [],
                tlPembayaranBPJSObat: [],
                kodediagnosa: [],
                kategoriPasien: null,
                TransKlinikIDRiwayatRekamMedis: null,
                SuratRujukBpjs: null,
                datarujukan: {
                    faskes: null,
                    spesialis: null,
                    subspesialis: null,
                    catatan: null,
                    tglrujukan: null,
                },
                tacc: {
                    option: [],
                    type: null,
                    faktor: null,
                    alasan: null,
                },
                bpjs_health_data: null,
            }
        },
        mounted() {
            this.buildData();
            this.buildDataRujukan();
        },
        watch: {
            dataRM() {
                this.buildData();;
                this.buildDataRujukan();
            }
        },
        methods: {
            async buildDataRujukan() {
                let rujukan = this.dataRujukan
                if (rujukan) {
                    if (rujukan.ref_khusus) {
                        this.datarujukan = {
                            faskes: rujukan.ppkRujukan || null,
                            spesialis: rujukan.ref_khusus.nmKhusus || null,
                            subspesialis: rujukan.subSpesialis_khusus ? rujukan.subSpesialis_khusus.nmSubSpesialis : null,
                            catatan: rujukan.catatan || null,
                            tglrujukan: rujukan.tglRencanaBerkunjung || null,
                        }
                    }
                    if (rujukan.subSpesialis_spesialis) {
                        this.datarujukan = {
                            faskes: rujukan.ppkRujukan || null,
                            spesialis: null,
                            subspesialis: rujukan.subSpesialis_spesialis.nmSubSpesialis || null,
                            catatan: rujukan.catatan || null,
                            tglrujukan: rujukan.tglRencanaBerkunjung || null,
                        }
                    }
                }
                
                if (this.dataRM && this.dataRM.bpjs_health_data) {
                    this.bpjs_health_data = this.dataRM.bpjs_health_data;
                    this.tacc.alasan = this.dataRM.bpjs_health_data.alasan_tacc;

                    let kd_tacc = this.dataRM.bpjs_health_data.kd_tacc;
                    if (this.checkValueData(kd_tacc)) this.tacc.type = kd_tacc != '-1' ? 'Y' : 'T';
                    else {
                        this.tacc.type = null;
                        this.tacc.faktor = null;
                        this.tacc.alasan = null;
                    }

                    if (this.tacc.type == 'Y') {
                        if (this.tacc.option.length < 1) this.tacc.option = await this.fetchFaktorRujukan();
                        const data = this.tacc.option.find(v => v.value == kd_tacc);
                        if (data) this.tacc.faktor = data.label || '-';
                    }
                }
            },
            buildData() {
                this.tlPembayaranBPJSTindakan = [];
                this.tlPembayaranBPJSObat = [];
                this.tlPembayaranTindakan = [];
                this.tlPembayaranObat = [];
                let resDig = [];
                this.kategoriPasien = this.dataRM.transklinik.kategori_id;
                const pembayaran = this.dataRM.transklinik.pembayaran[0];
                if (pembayaran) {
                    if (this.dataRM.transklinik.kategori_id == 2) {
                        pembayaran.detail.forEach((item) => {
                            if (item.from_bpjs == 1) {
                                if (item.bpjs_sk_type == 0) {
                                    this.tlPembayaranBPJSTindakan.push(item)
                                } else {
                                    this.tlPembayaranBPJSObat.push(item)
                                }
                            }
                            if (item.from_bpjs == 0) {
                                if (item.layanan) {
                                    if (item.layanan.kategori_id == 4) {
                                        this.tlPembayaranTindakan.push(item);
                                    } else if (item.layanan.kategori_id == 2 || item.layanan.kategori_id == 3) {
                                        this.tlPembayaranObat.push(item);
                                    }
                                }
                            }
                        });
                        this.kodediagnosa = this.dataRM.kode_diagnosa;
                    } else {
                        pembayaran.detail.forEach((item) => {
                            if (item.layanan) {
                                if (item.layanan.kategori_id == 4) {
                                    this.tlPembayaranTindakan.push(item);
                                } else if (item.layanan.kategori_id == 2 || item.layanan.kategori_id == 3) {
                                    this.tlPembayaranObat.push(item);
                                }
                            } else {
                                if (item.kode_layanan == 'OUTSIDE_SOURCE') {
                                    resDig.push(item);
                                }
                            }
                        });

                        if (resDig.length > 0) {
                            resDig.forEach((item) => {
                                this.tlPembayaranObat.push(item)
                            })
                        }
                    }
                }
                
                this.$nextTick(() => {
                    this.TransKlinikIDRiwayatRekamMedis = this.dataRM.transklinik_id;
                    this.SuratRujukBpjs = JSON.parse(this.dataRM.transklinik.surat_rujuk_bpjs);
                })
            },
            dateFormat(d) {
                return moment(d).format('DD-MM-YYYY')
            },
            setStatusPulang() {
                if (this.tacc.type == 'Y') return 'Rujukan dengan TACC';
                else if (this.tacc.type == 'T') return 'Rujukan tanpa TACC';
                return this.dataRM.bpjs_nmStatusPulang;
            },
        }
    }
</script>

<style>
    .mb-header {
        margin-bottom: -15px;
    }
</style>